import React, { useMemo, useCallback } from 'react';
import Select from 'react-select';

const vehicleOptions = [
    'Stock 4x4',
    'Modified/High Clearance 4x4',
    'AWD/Crossover',
    'Adventure Vans (Sprinters & Transits)',
    'Oversized Rigs (Fusos, EarthRoamers, etc)',
    'Adventure Motorcycle'
].map(v => ({ value: v, label: v }));

const VehicleSelect = ({ selectedVehicles, setSelectedVehicles }) => {
    const handleChange = useCallback((selectedOptions) => {
        const newValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        setSelectedVehicles(newValues);
    }, [setSelectedVehicles]);

    // Memoize the value calculation to prevent unnecessary recalculations
    const value = useMemo(() => {
        // Ensure selectedVehicles is always an array
        const vehicles = Array.isArray(selectedVehicles) ? selectedVehicles : [];
        return vehicleOptions.filter(opt => vehicles.includes(opt.value));
    }, [selectedVehicles]);

    return (
        <div style={{ marginBottom: '1rem' }}>
            <label className="block mb-1 text-sm font-bold">Recommended Vehicles (select all appropriate vehicle types)</label>
            <Select
                options={vehicleOptions}
                isMulti
                value={value}
                onChange={handleChange}
                placeholder="Select vehicle types"
                isSearchable
                // Add a key to help React identify this component
                key="vehicle-select"
            />
        </div>
    );
};

export default VehicleSelect;